import { render, staticRenderFns } from "./DocumentType.vue?vue&type=template&id=7ce7d2c6&"
import script from "./DocumentType.vue?vue&type=script&lang=js&"
export * from "./DocumentType.vue?vue&type=script&lang=js&"
import style0 from "./DocumentType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports